import { useMemo } from 'react';

import qs from 'qs';

import type { SuggestedPetition } from '../../../../../../../../shared/api';

export function useSuggestedPetitionSignErrorRedirect({
	parentPetitionId,
	petition,
	gridPosition,
	sourceLocation,
}: {
	parentPetitionId?: string;
	petition: SuggestedPetition;
	gridPosition: number;
	sourceLocation?: string;
}): string {
	return useMemo(
		() =>
			`/p/${petition.node.slug}${qs.stringify(
				{
					show_sign: true,
					// WARN: this will be set when coming from the update page, which could be confusing
					original_footer_petition_id: parentPetitionId,
					grid_position: gridPosition,
					pt: petition.promotionToken,
					pt_algorithm: petition.algorithm,
					source_location: sourceLocation,
				},
				{ addQueryPrefix: true },
			)}`,
		[parentPetitionId, petition, gridPosition, sourceLocation],
	);
}
